import iso6391LanguageMeta from '@src/data/ISO-639-1-language-meta.json';

import type { LanguageOptionMeta } from '@src/domains/products/features/product-booking/types/language';

export type Iso6391LanguageMeta = Record<string, LanguageOptionMeta>;

/** Loaded once at module init; shared synchronously across the app. */
export const ISO_639_1_LANGUAGE_META: Iso6391LanguageMeta = iso6391LanguageMeta;

export const getIso6391LanguageMetaSync = (): Iso6391LanguageMeta => ISO_639_1_LANGUAGE_META;

/** @deprecated Prefer `getIso6391LanguageMetaSync()` — meta is available synchronously after bundle load. */
export const loadIso6391LanguageMeta = (): Promise<Iso6391LanguageMeta> => Promise.resolve(ISO_639_1_LANGUAGE_META);

export const __resetIso6391LanguageMetaForTests = (): void => {
  // No-op: meta is bundled statically. Tests should mock this module when isolation is needed.
};
